import $ from 'jquery';
window.addEventListener('px-ready',function(){
    $('.px-header .mobile-menu .menu-item-has-children>a').on('click',function(){
        if($(this).parent().hasClass('is-menu-open')){

        }else{
            $('.px-header .mobile-menu .menu-item-has-children').removeClass('is-menu-open')
            $(this).parent().addClass('is-menu-open')
            return false;
        }
    })
    $('.searchform [type="submit"]').on('click',function(){
        if(!$('.searchform [name=s]').val()){
            console.log('noval')
            $('.searchform [name=s]').focus();
            return false;
        }
    })
    $(window).on('resize',function(){
        //console.log('reset')
        $('.mobile-menu .sub-menu').each(function(){
            //console.log('in1')
            var h = 16;
            $(this).find('li').each(function(){
                //console.log('in2')
                h += $(this).height();
            })
            $(this).css('max-height',h);
        })
    }).trigger('resize')
})